/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `dolnoslaskie` - dolnośląskie
 * * `kujawsko-pomorskie` - kujawsko-pomorskie
 * * `lubelskie` - lubelskie
 * * `lubuskie` - lubuskie
 * * `lodzkie` - łódzkie
 * * `malopolskie` - małopolskie
 * * `mazowieckie` - mazowieckie
 * * `opolskie` - opolskie
 * * `podkarpackie` - podkarpackie
 * * `podlaskie` - podlaskie
 * * `pomorskie` - pomorskie
 * * `slaskie` - śląskie
 * * `swietokrzyskie` - świętokrzyskie
 * * `warminsko-mazurskie` - warmińsko-mazurskie
 * * `wielkopolskie` - wielkopolskie
 * * `zachodniopomorskie` - zachodniopomorskie
 */
export type VoivodeshipEnum = typeof VoivodeshipEnum[keyof typeof VoivodeshipEnum];


export const VoivodeshipEnum = {
  dolnoslaskie: 'dolnoslaskie',
  'kujawsko-pomorskie': 'kujawsko-pomorskie',
  lubelskie: 'lubelskie',
  lubuskie: 'lubuskie',
  lodzkie: 'lodzkie',
  malopolskie: 'malopolskie',
  mazowieckie: 'mazowieckie',
  opolskie: 'opolskie',
  podkarpackie: 'podkarpackie',
  podlaskie: 'podlaskie',
  pomorskie: 'pomorskie',
  slaskie: 'slaskie',
  swietokrzyskie: 'swietokrzyskie',
  'warminsko-mazurskie': 'warminsko-mazurskie',
  wielkopolskie: 'wielkopolskie',
  zachodniopomorskie: 'zachodniopomorskie',
} as const;
